import { AxiosError } from "axios";

const handleApiError = (error: any): boolean => {
    if (error instanceof AxiosError) {

        if (error.code === 'ERR_NETWORK') {
            console.error('Network error: Please check your internet connection and API URL.');
            return true;
        }

        switch (error.response?.status) {
            case 401:
                console.error('Unauthorized: Invalid or missing token.');
                break;
            case 403:
                console.error('Forbidden: You do not have required permissions for this operation');
                break;
            default:
                console.error('Error fetching documents:', error);
        }

        return true;
    }
    return false;
};

export default handleApiError;